// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__a9iLE","chip__indicator":"StatusChip_chip__indicator__jH2ZC"};